var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-confirm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.000000, -108.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.458483,108 L164,110.559209 L149.460453,125.199969 C149.420736,125.239962 149.378478,125.275897 149.334194,125.307771 C149.289577,125.365472 149.240283,125.421671 149.186953,125.475373 L149.186953,125.475373 L149.175977,125.48633 C148.474167,126.18087 147.342202,126.174976 146.647662,125.473166 L146.647662,125.473166 L140,118.755919 L142.541517,116.19671 L147.921,121.631 L161.458483,108 Z",
    id: "px-confirm"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxConfirm);
export default __webpack_public_path__ + "static/media/px-confirm.4fa71664577167563290b900075bab30.svg";
export { ForwardRef as ReactComponent };